<script>
  import router from '../../../lib/router';
  import { onMount } from 'svelte';
  import session from '../../../lib/session';
  import { t9n } from '../../../lib/translate.js';
  import Dialog from '../../../lib/components/Dialog.svelte';
  import APIClient from '../../../state-charts/api-client';

  import { TS } from '../../../config/translation-keys.js';
  import { show_message } from '../../../lib/flash';

  export let applications;
  export let order_uuid;
  export let hidden_users;
  export let order;

  export let transaction_id;
  export let show_nets;
  export let nets_status;
  export let call_select_worker;
  export let select_applicant_flag;
  export let worker_id;
  export let make_a_copy;

  let is_opened = [];
  let select_make_a_copy;
  let select_id;
  let wait_api = false;

  const hide_user = async id => {
    wait_api = true;
    await APIClient.hide_application(
      {
        order_uuid: order_uuid,
        worker_id: applications[id].worker.basic_profile.user_id,
      },
      () => {
        wait_api = false;
        location.reload();
      }
    );
  };

  const unhide_user = async id => {
    wait_api = true;
    await APIClient.show_application(
      {
        order_uuid: order_uuid,
        worker_id: applications[id].worker.basic_profile.user_id,
      },
      () => {
        wait_api = false;
        location.reload();
      }
    );
  };

  const toggle_open = id => {
    is_opened[id] = !is_opened[id];
  };

  const init = () => {
    // for(let i = 0; applications.length; i++){
    //     is_opened[i] = false;
    // }
  };

  const init_nets_form = async () => {
    let button_multiple = document.getElementById('choose_multiple');
    let button_only_one = document.getElementById('choose_only_one');
    if (button_multiple) button_multiple.disabled = true;
    if (button_only_one) button_only_one.disabled = true;
    let data = {
      order_uuid: order_uuid,
      app: true,
    };
    const transaction_data = await APIClient.init_reserve_card(data);
    if (!!transaction_data) {
      nets_status = 'reserve';
      show_nets = true;
      transaction_id = transaction_data.reference;
      if (button_multiple) button_multiple.disabled = false;
      if (button_only_one) button_only_one.disabled = false;
    }
  };

  const select_worker = async (make_a_copy, id) => {
    let data = {
      make_a_copy: Boolean(make_a_copy),
      order_uuid: order_uuid,
      worker_id: applications[id].worker.basic_profile.user_id,
    };
    let result = await APIClient.select_worker(data);
    if (!!result) {
      show_message(t9n(TS.ORDER_SUCCESSFULL_WORKER_SELECTION), 'success');
      setTimeout(() => {
        location.reload();
      }, 1500);
    }
  };

  const select_worker_with_id = async (make_a_copy, worker_id) => {
    let data = {
      make_a_copy: Boolean(make_a_copy),
      order_uuid: order_uuid,
      worker_id: worker_id,
    };
    let result = await APIClient.select_worker(data);
    if (!!result) {
      show_message(t9n(TS.ORDER_SUCCESSFULL_WORKER_SELECTION), 'success');
      setTimeout(() => {
        location.reload();
      }, 1500);
    }
  };

  const select_applicant = async (make_a_copy, id) => {
    let payment_type = order.payment.payment_type;
    let payment_status = order.payment.payment_status;
    if (
      payment_type === 'payment_type_credit_card' &&
      payment_status === 'payment_status_not_payed'
    ) {
      select_make_a_copy = make_a_copy;
      select_id = id;
      await init_nets_form();
    } else {
      if (select_applicant_flag) {
        await select_worker_with_id(make_a_copy, id);
      } else {
        await select_worker(make_a_copy, id);
      }
    }

    // location.reload();
  };

  const create_hide_dialog = id => {
    let target = document.querySelector('.hide-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'select-message',
        title: t9n(TS.ORDER_HIDE_USER),
        content: t9n(TS.ORDER_HIDE_USER_CONTENT),
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            wait_api: wait_api,
            label: t9n(TS.TXT_YES),
            action: async () => {
              dialog.close();
              await hide_user(id);
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_hide_dialog = id => {
    let dialog = create_hide_dialog(id);
    dialog.open();
  };

  const create_unhide_dialog = id => {
    let target = document.querySelector('.hide-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'select2-message',
        title: t9n(TS.ORDER_UNHIDE_USER),
        content: t9n(TS.ORDER_UNHIDE_USER_CONTENT),
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            wait_api: wait_api,
            label: t9n(TS.TXT_YES),
            action: async () => {
              dialog.close();
              await unhide_user(id);
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_unhide_dialog = id => {
    let dialog = create_unhide_dialog(id);
    dialog.open();
  };

  const create_dialog = id => {
    let target = document.getElementById('select-dialog-in-order');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'select-dialog-opened',
        title: t9n(TS.ORDER_SELECT_APPL),
        content: t9n(TS.ORDER_MORE_APPL),
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            id: 'choose_multiple',
            label: t9n(TS.TXT_YES),
            action: async () => {
              await select_applicant(true, id);
              dialog.close();
            },
            classes: [],
          },
          {
            id: 'choose_only_one',
            label: t9n(TS.ORDER_NO_ONLY_ONE),
            action: async () => {
              await select_applicant(false, id);
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_select_dialog = id => {
    if(order.payment.payment_status !== 'payment_status_payment_needed'){
      let dialog = create_dialog(id);
      dialog.open();
    } else{

    }
  };


  const format_rating_str = rating => {
    if(!!rating){
      if (rating > 0) return `+ ${rating}`;
      if (rating < 0) return `${rating}`;
      if (rating === 0) return rating;
    }
    return 0;
  };

  const view_profile = id => {
    let route = `/profile?order_uuid=${order_uuid}&user_id=${applications[id].worker.basic_profile.id}&applicant=true`
    let age_range = applications[id].worker.worker_profile.age_range;
    if(!!age_range){
      let a = age_range.split('_')
      age_range =  a.slice(2).join('_');
      route += `&age_range=${age_range}`;
    }

    router.navigate(route);
  };

  const open_chat = async (partner_id, i) => {
    router.navigate(
      `chats/${order.order_uuid}/partner/${partner_id}/index/${i}`
    );
  };

  $: if (call_select_worker === true) {
    (async () => {
      if (select_applicant_flag) {
        await select_worker_with_id(make_a_copy, worker_id);
      } else {
        await select_worker(select_make_a_copy, select_id);
      }
    })();

  }

  $: if (select_applicant_flag){
    (async () => {
      await select_applicant(make_a_copy, worker_id)
    })();
  }
  onMount(init);
</script>

<!-- header section -->
<div>
  <div class="mdc-data-table table-min-height fade-in" style="display: flex;">
    <table class="mdc-data-table__table">
      <thead>
        <tr class="mdc-data-table__header-row mdc-data-table-bold">
          <th class="mdc-data-table__header-cell numeric" />
          <th class="mdc-data-table__header-cell numeric">
            {t9n(TS.ORDER_NAME)}
          </th>
          <th class="mdc-data-table__header-cell numeric">
            {t9n(TS.PROFILE_FEEDBACKS)}
          </th>
          <!--                <th class="mdc-data-table__header-cell numeric">{t9n(TS.ORDER_COMPL_JOBS)}</th>-->
          <th class="mdc-data-table__header-cell numeric" style="width: 300px">
            {t9n(TS.ORDER_WORK_INFO)}
          </th>
          <th class="mdc-data-table__header-cell numeric" />
        </tr>
      </thead>
      <tbody>

        <!-- section for table data -->
        {#each applications as application, i}
          {#if !application.hidden || (hidden_users && application.hidden)}
            <tr class="mdc-data-table__row" on:click={() => toggle_open(i)}>
              <td
                class="mdc-data-table__cell numeric"
                style="position: relative;">
                {#if application.worker.worker_profile.age_range !== "age_range_under_15" && application.worker.worker_profile.age_range !== "age_range_15_17"}
<!--                  <img src="/assets/age18.png" class="circle-age-18-img" />-->
                  <span class="circle-under-15">{t9n(TS.LABEL_OVER_18)}</span>
                {/if}
                {#if application.worker.worker_profile.age_range === "age_range_under_15"}
                  <span class="circle-under-15">{t9n(application.worker.worker_profile.age_range)}</span>
                {/if}
                <img
                  src={application.worker.basic_profile.image_url}
                  width="70"
                  height="70" />
              </td>
              <td class="mdc-data-table__cell numeric" style="max-width: 111px">
                {application.worker.basic_profile.first_name}
                {application.worker.basic_profile.last_name}
              </td>
              <td class="mdc-data-table__cell numeric">
                {application.worker.worker_profile.stats.worker_feedbacks.count}
              </td>
              <!--                <td class="mdc-data-table__cell numeric">{application.worker.worker_profile.stats.worker_completed_orders}</td>-->
              <td class="mdc-data-table__cell numeric">
                {#if application.message !== null}
                  <div>{application.message}</div>
                {/if}
              </td>
              <td class="mdc-data-table__cell numeric">
                {#if !is_opened[i]}
                  <button
                    id="open_applicants"
                    class="mdc-button mdc-button--unelevated">
                    <span class="mdc-button__ripple" />
                    <i class="material-icons">keyboard_arrow_down</i>
                  </button>
                {:else}
                  <button class="mdc-button mdc-button--unelevated">
                    <span class="mdc-button__ripple" />
                    <i class="material-icons">keyboard_arrow_up</i>
                  </button>
                {/if}

              </td>

            </tr>

            {#if is_opened[i] === true}
              <tr class="no-hover">
                <td colspan="100%">
                  <section style="display: flex;">

                    <div style="margin-top: 12px; width: 100%;">
                      <div style="display: inline-flex; width: 100%;">
                        <div>
                          <p>
                            <b>{t9n(TS.PROFILE_CITY_LABEL)}</b>
                            {application.worker.basic_profile.address.city}
                          </p>
                          <p>
                            <b>{t9n(TS.PROFILE_POSTAL_CODE_LABEL)}</b>
                            {application.worker.basic_profile.address.postal_code}
                          </p>
<!--                          <p>-->
<!--                            <b>{t9n(TS.SETTINGS_LABEL_WORKER_TYPE)}</b>-->
<!--                            {t9n(application.worker.worker_profile.worker_type)}-->
<!--                          </p>-->
                        </div>
                        <div
                          style="display: flex; margin-left: auto;
                          margin-bottom: 10px">
                          {#if application.hidden}
                            <button
                              on:click={() => toggle_unhide_dialog(i)}
                              style="margin: 1px; margin-right: 1px"
                              class="mdc-button mdc-button--unelevated margin-5">
                              <span class="mdc-button__ripple" />
                              {t9n(TS.ORDER_UNHIDE_USER)}
                            </button>
                          {:else}
                            <button
                              on:click={() => toggle_hide_dialog(i)}
                              style="margin: 1px; margin-right: 1px"
                              class="mdc-button mdc-button--unelevated margin-5">
                              <span class="mdc-button__ripple" />
                              {t9n(TS.ORDER_HIDE_USER)}
                            </button>
                          {/if}

                          <button
                            on:click={() => view_profile(i)}
                            style="margin: 1px; margin-right: 1px"
                            class="mdc-button mdc-button--unelevated margin-5">
                            <span class="mdc-button__ripple" />
                            {t9n(TS.ORDER_VIEW_PROFILE)}
                          </button>
                          <button
                            id="select_dialog"
                            on:click={() => toggle_select_dialog(i)}
                            style="margin: 1px;"
                            class="mdc-button mdc-button--unelevated margin-5">
                            <span class="mdc-button__ripple" />
                            {t9n(TS.TXT_SELECT)}
                          </button>
                          <button
                            id="open_chat"
                            on:click={() => open_chat(application.worker.basic_profile.user_id, i)}
                            style="margin: 1px;"
                            class="mdc-button mdc-button--unelevated margin-5">
                            <span class="material-icons grow">chat</span>
                          </button>
                        </div>
                      </div>
                      {#if application.worker.basic_profile.short_description_worker !== null}
                        <p>
                          <b>{t9n(TS.ORDER_OWN_DESC)}</b>
                          {application.worker.basic_profile.short_description_worker}
                        </p>
                      {/if}
                    </div>

                    <!--                    <div class="divider" />-->

                  </section>
                </td>
              </tr>
            {/if}
          {/if}
        {/each}
      </tbody>
    </table>

  </div>

  <!-- bottom section: user details and buttons -->
</div>

<div id="select-dialog-in-order" />
<div class="hide-dialog" />

<style>
  .divider {
    display: flex;
    flex: 1;
  }

  .numeric {
    text-align: center;
  }

  .mdc-data-table {
    border: 0;
  }

  .mdc-data-table__header-cell {
    padding-right: 7px;
    padding-left: 7px;
  }

  .mdc-data-table__table {
    border: 0;
    white-space: break-spaces;
    border-collapse: collapse;
  }

  .mdc-data-table__row {
    cursor: pointer;
  }

  th {
    color: #616161;
    font-weight: 800;
    text-align: left;
    max-width: 300px;
    min-width: 150px;
    word-wrap: break-word;
    white-space: normal;
  }

  td {
    color: #616161;
    /*width: 100%;*/
    font-weight: 500;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    max-width: 190px;
  }

  p {
    font-size: 0.875rem;
    margin-left: 15px;
    color: #616161;
    text-align: left;
    margin-top: 3px;
    margin-bottom: 3px;
  }

  img {
    border-radius: 50%;
  }

  .circle-age-18-img {
    position: absolute;
    height: 29px;
    width: 29px;
    right: 29px;
  }

  .circle-under-15{
      position: absolute;
      color: white;
      border: 1px solid white;
      background-color: #21adbb;
      font-weight: 800;
      font-size: 12px;

      height: 14px;
      width: fit-content;
      border-radius: 5px;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      padding-top: 2px;
      padding-bottom: 6px;
      padding-left: 4px;
      padding-right: 4px;
  }

  td > div {
    /*height: 20px;*/
    /*overflow: hidden;*/
    max-height: 20px;
    transition: max-height 1s ease-out;
    overflow: hidden;
  }

  .mdc-data-table__row:hover > td > div {
    /*height: auto;*/
    /*transition: height 2s;*/
    max-height: 500px;
    transition: max-height 2s ease-in;
  }

  tr:not(.no-hover):hover {
    height: 100%;
    max-height: fit-content;
  }
</style>
